import DOMPurify from "dompurify";

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function looksLikeHtml(str) {
  return /<\/?[a-z][\s\S]*>/i.test(String(str ?? ""));
}

function normalizeNewlinesInHtmlContent(html) {
  const source = String(html).replace(/\r\n/g, "\n");
  const withoutBetweenTagBreaks = source.replace(/>\s*\n+\s*</g, "><");

  return withoutBetweenTagBreaks
    .split(/(<[^>]+>)/g)
    .map((segment) => {
      if (!segment || /^<[^>]+>$/.test(segment)) return segment;
      return segment.replace(/\n{2,}/g, "</p><p>").replace(/\n/g, "<br />");
    })
    .join("");
}

function decodeHtmlEntities(str) {
  return String(str)
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#0*39;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, "&");
}

/**
 * Normaliza contenido proveniente del admin.
 * - Si viene como HTML, se sanitiza antes de renderizar.
 * - Si viene como texto plano, se convierte a HTML preservando saltos de línea.
 */
export function normalizeAdminRichText(input) {
  const raw = input == null ? "" : String(input);
  const trimmed = raw.trim();
  if (!trimmed) return "";

  // Algunos backends guardan HTML "escapado" (ej: &lt;strong&gt;).
  // Si es el caso, lo decodificamos una vez para poder renderizar estilos.
  const maybeDecoded =
    /&lt;[a-z][\s\S]*&gt;/i.test(trimmed) ||
    /&lt;\/[a-z][\s\S]*&gt;/i.test(trimmed)
      ? decodeHtmlEntities(trimmed)
      : trimmed;

  if (looksLikeHtml(maybeDecoded)) {
    return sanitizeAdminHtml(normalizeNewlinesInHtmlContent(maybeDecoded));
  }

  const safe = escapeHtml(maybeDecoded).replace(/\r\n/g, "\n");
  const paragraphs = safe
    .split(/\n{2,}/g)
    .map((p) => p.trim())
    .filter(Boolean)
    .map((p) => `<p>${p.replace(/\n/g, "<br />")}</p>`)
    .join("");

  return paragraphs || `<p>${safe.replace(/\n/g, "<br />")}</p>`;
}

function sanitizeAdminHtml(html) {
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target"],
  });
}
